import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { PriceTypeDto } from "../../../../dtos/catalogs/pricetype/PriceTypeDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { NFLookupCurrency } from "../../../Shared/NewForms/NFlookupCurrency";
import { NFCheckBoxInput } from "../../../Shared/NewForms/NFCheckBoxInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFLookupPriceType } from "../../../Shared/NewForms/NFLookupPriceType";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import PriceTypeDetailSkeleton from "./PriceTypeDetailSkeleton";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";

interface IProps {
  model: PriceTypeDto | null;
  modelUpdatedEvent: (newModel: PriceTypeDto) => void;
}

interface ContractModel {
  id: string;
  name: string;
  description?: string;
  status: number;
  createdDate?: Date;
  uniqueCode?: string;
  group?: string;
  currencyId?: string;
  priceIncludesVat: boolean;
  type?: number;
  number?: number;
  basePriceId?: string;
  roundup?: boolean;
  changeByPercentage?: number;
}
export const PriceTypeDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const [selectType, setSelectType] = useState(0);

  const handleTypeChange = (value: any) => {
    setSelectType(value);
  };
  const Status = [
    { id: 0, name: "Dynamic" },
    { id: 1, name: "Static" }
  ];
  const RoundingRule = [
    {
      id: 0,
      name: "0.01"
    },
    {
      id: 1,
      name: "0.05"
    },
    {
      id: 2,
      name: "0.1"
    },
    {
      id: 3,
      name: "0.5"
    }
  ];
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<ContractModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("name", model.name);
      setValue("description", model.description);
      setValue("status", model.status);
      setValue("createdDate", model.createdDate);
      setValue("uniqueCode", model.uniqueCode);
      setValue("group", model.group);
      setValue("currencyId", model.currencyId);
      setValue("priceIncludesVat", model.priceIncludesVat);
      setValue("type", model.type);
      setValue("number", model.number);
      setValue("basePriceId", model.basePriceId);
      setValue("roundup", model.roundup);
      setValue("changeByPercentage", model.changeByPercentage);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: ContractModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    // return;
    if (action === "save") {
      const newModel: PriceTypeDto = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
      await saveHandler(newModel);
    }
    console.log("form submit finish");
  };

  if (!model) {
    return (
      <>
        <PriceTypeDetailSkeleton />
      </>
    );
  }

  const handleTabChange = (index: number) => {
    setTabIndex(index);
  };
  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
        </NFTabs>
        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <Row>
            <Col sm={6}>
              <NFDateInput fieldName={"createdDate"} title={"CreatedDate"} disabled />
            </Col>
            <Col sm={6}>
              <NFTextInput title={"Created User"} fieldName={"createdUser"} disabled={true} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Name"} fieldName={"name"} />
            </Col>
            <Col sm={6}>
              <NFTextInput title={"Unique code"} fieldName={"uniqueCode"} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFTextInput fieldName={"description"} title={"Description"} />
            </Col>
            <Col sm={6}>
              <NFLookupInput title={"Type"} fieldName={"type"} items={Status} onValueChange={handleTypeChange} />
            </Col>
          </Row>
          {selectType === 0 && (
            <Row>
              <Col sm={6}>
                <NFLookupPriceType title={"Basic Price"} fieldName={"basePriceId"} />
              </Col>
              <Col sm={2}>
                <NFCheckBoxInput title="roundup" fieldName="roundup" />
              </Col>{" "}
              <Col sm={4}>
                <NFIntInput title="Change by Percentage %" fieldName="changeByPercentage" min={0} max={100} />
              </Col>
            </Row>
          )}

          <Row>
            <Col sm={6}>
              <NFLookupInput title="Rounding Rule" fieldName="number" items={RoundingRule} />
            </Col>
            <Col sm={6}>
              <NFCheckBoxInput title="Price Includes VAT" fieldName="priceIncludesVat" />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFTextInput fieldName={"group"} title={"Group"} />
            </Col>
            <Col sm={6}>
              <NFLookupCurrency fieldName={"currencyId"} title={"Currency"} />
            </Col>
          </Row>
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
